var _rect, _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatternHalfScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 588,
    height: 1024,
    viewBox: "0 0 588 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4023_10355)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4023_10355)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(0 -28)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4023_10355",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -28,
    width: 1920,
    height: 1080
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 -28H0V1052H1920V-28Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4023_10355)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1920 -28H0V1052H1920V-28Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4023_10355",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -28,
    width: 1920,
    height: 1080
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1920 -28H0V1052H1920V-28Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4023_10355)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1920 -28H0V1052H1920V-28Z",
    fill: "#FFB600"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4023_10355",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -28,
    width: 1921,
    height: 1081
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1921 -28H0V1053H1921V-28Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4023_10355)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0996 -17.5H165.181V483.971H12.0996V-17.5Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.181 -17.5H613.89V152.171H165.181V-17.5Z",
    fill: "#DB536A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.181 152.171H388.781V323.33H165.181V152.171Z",
    fill: "#EB8C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.181 312.813H388.781V483.971H165.181V312.813Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.776 152.171H613.89V323.33H388.776V152.171Z",
    fill: "#EB8C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.776 312.813H613.89V483.971H388.776V312.813Z",
    fill: "#D04A02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0996 483.971H501.333V1042.5H12.0996V483.971Z",
    fill: "#EB8C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.333 483.971H613.89V1042.5H501.333V483.971Z",
    fill: "#D04A02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1318.41 880.365V1032.72H1748.13V880.365H1318.41ZM797.751 809.838V1032.72H950.788V809.838H797.751ZM623.771 809.838V1032.72H777.5V809.838H623.771ZM1543.21 721.186V862.143H1748.13V721.186H1543.21ZM1318.41 721.186V862.143H1522.96V721.186H1318.41ZM1768.38 550.773V1032.72H1900.73V550.787H1768.38V550.773ZM1543.21 550.773V702.964H1748.13V550.773H1543.21ZM1318.41 550.773V702.964H1522.96V550.773H1318.41ZM971.056 550.773V1032.72H1298.16V550.787H971.056V550.773ZM623.785 492.492V791.615H950.8V492.492H623.785ZM511.285 492.492V1032.72H603.517V492.506H511.285V492.492ZM20.3656 492.492V1032.72H491.031V492.506H20.3666L20.3656 492.492ZM399.276 322.36V474.284H603.531V322.36H399.276ZM175.02 322.36V474.284H379.008V322.36H175.02ZM971.056 232.682V532.564H1298.16V232.682H971.056ZM399.276 163.2V304.151H603.531V163.2H399.276ZM175.02 163.2V304.151H379.008V163.2H175.02ZM1431.82 -9.792V532.578H1900.75V-9.792H1431.82ZM1318.42 -9.792V532.578H1411.57V-9.792H1318.42ZM1144.36 -9.792V214.473H1298.17V-9.792H1144.36ZM971.07 -9.792V214.473H1124.11V-9.792H971.07ZM623.799 -9.792V474.3H950.816V-9.792H623.799ZM175.034 -9.792V144.986H603.517V-9.792H175.034ZM20.3666 -9.792V474.3H154.767V-9.792H20.3666ZM950.8 -28H1921.01V1053H0.0996094V-28H950.8Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1318.41 880.365V1032.72H1748.13V880.365H1318.41ZM797.751 809.838V1032.72H950.788V809.838H797.751ZM623.771 809.838V1032.72H777.5V809.838H623.771ZM1543.21 721.186V862.143H1748.13V721.186H1543.21ZM1318.41 721.186V862.143H1522.96V721.186H1318.41ZM1768.38 550.773V1032.72H1900.73V550.787H1768.38V550.773ZM1543.21 550.773V702.964H1748.13V550.773H1543.21ZM1318.41 550.773V702.964H1522.96V550.773H1318.41ZM971.056 550.773V1032.72H1298.16V550.787H971.056V550.773ZM623.785 492.492V791.615H950.8V492.492H623.785ZM511.285 492.492V1032.72H603.517V492.506H511.285V492.492ZM20.3656 492.492V1032.72H491.031V492.506H20.3666L20.3656 492.492ZM399.276 322.36V474.284H603.531V322.36H399.276ZM175.02 322.36V474.284H379.008V322.36H175.02ZM971.056 232.682V532.564H1298.16V232.682H971.056ZM399.276 163.2V304.151H603.531V163.2H399.276ZM175.02 163.2V304.151H379.008V163.2H175.02ZM1431.82 -9.792V532.578H1900.75V-9.792H1431.82ZM1318.42 -9.792V532.578H1411.57V-9.792H1318.42ZM1144.36 -9.792V214.473H1298.17V-9.792H1144.36ZM971.07 -9.792V214.473H1124.11V-9.792H971.07ZM623.799 -9.792V474.3H950.816V-9.792H623.799ZM175.034 -9.792V144.986H603.517V-9.792H175.034ZM20.3666 -9.792V474.3H154.767V-9.792H20.3666ZM950.8 -28H1921.01V1053H0.0996094V-28H950.8Z",
    fill: "#FFB600"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4023_10355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(0 -28)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4023_10355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(0 -28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternHalfScreen);
export default __webpack_public_path__ + "static/media/Pattern_HalfScreen.6c370419490fe97a910a2e8c4741bce2.svg";
export { ForwardRef as ReactComponent };